module.exports = __webpack_public_path__ + "img/banner1.75ab47e8.png";